module.exports = __webpack_public_path__ + "static/media/ic-mob-add-mail.70874f83.svg";